<template>
  <b-row>
    <b-col class="pl-0">
      <b-form-group vertical class="mb-1 mr-4" label="Тип доставки:">
      <b-form-select :value="filterDeliveryType" @input="changedDeliveryType" :options="deliveryTypeOptions"></b-form-select>
    </b-form-group>
    </b-col>
  </b-row>
</template>
<script>
import ACT from '../constants/vuexActions'
export default {
  name: 'RestPointFilter',
  props: {
    namespace: {
      type: String,
      required: true
    }
  },
  methods: {
    changedDeliveryType (newVal) {
      this[ACT.UPDATE_SELECTED_DELIVERY_TYPE](newVal)
    },
    [ACT.UPDATE_SELECTED_DELIVERY_TYPE] (payload) {
      this.$store.dispatch(
        `${this.namespace}/${ACT.UPDATE_SELECTED_DELIVERY_TYPE}`,
        payload
      )
    }
  },
  computed: {
    deliveryTypeOptions () {
      return this.$store.getters[`${this.namespace}/deliveryTypeOptions`]
    },
    filterDeliveryType () {
      return this.$store.getters[`${this.namespace}/filterDeliveryType`]
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DeliveryTypeFilter.vue